/**
 * 获取localStorage对象并转成对应的类型
 * @param name localStorage设置名称
 */
 export function getLocal(name) {
    const l = localStorage.getItem(name);
    const local = JSON.parse(l !== null ? l : '{}');
    return local;
}